var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Pagination',{attrs:{"current-page":1,"component-name":"EventEntry","data-attribute-name":"entry","data-list":_vm.dataList,"entries-per-page":5,"key-function":function (item) { return item.title + item.dateRange[0]; }}})}
var staticRenderFns = []

export { render, staticRenderFns }